import { useState, useRef, useLayoutEffect } from 'react';

interface CollapseProps {
  open: boolean;
  children: React.ReactNode;
}

// Collapsible section with smooth height transition
export const Collapse = ({ open, children }: CollapseProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState("0px");
  const [render, setRender] = useState(open);

  useLayoutEffect(() => {
    if (open) setRender(true);
  }, [open]);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (open) {
      setHeight("0px");
      requestAnimationFrame(() => {
        if (!el) return;
        const scrollHeight = el.scrollHeight;
        setHeight(scrollHeight + "px");
        const tid = setTimeout(() => {
          setHeight("auto");
        }, 120);
        return () => clearTimeout(tid);
      });
    } else {
      if (height === "auto") setHeight(el.scrollHeight + "px");
      requestAnimationFrame(() => {
        setHeight("0px");
      });
      const timeout = setTimeout(() => setRender(false), 120);
      return () => clearTimeout(timeout);
    }
    // eslint-disable-next-line
  }, [open]);

  return (
    <div
      ref={ref}
      style={{
        height: render ? height : "0px",
        overflow: "hidden",
        transition: "height 120ms cubic-bezier(0.4, 0, 0.2, 1)",
        display: render ? "block" : "none",
      }}
      aria-hidden={!open}
    >
      {render ? children : null}
    </div>
  );
};
